<template>
  <div>
    <va-date-picker
      :label="$t('users.untilTitle')"
      :config="{ minDate:new Date()}"
      v-model="until"
    />
    <message-area :label="$t('users.banLabelDescription')" v-model="description" />
    <va-button @click="submitForm" :disabled="!(until&&description)">{{$t('users.sendBan')}}</va-button>
  </div>
</template>
<script>
import moment from 'moment'
import MessageArea from '../../notification/components/MessageArea.vue'

export default {
  data() {
    return {
      until: '',
      description: '',
    }
  },
  methods: {
    submitForm() {
      this.$emit('submit', JSON.parse(JSON.stringify({ until: moment(this.until).format('YYYY-MM-DD'), description: this.description })))
      this.until = ''
      this.description = ''
    },
  },
  components: { MessageArea },
}
</script>
